import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import {PARSE_OFF, PARSE_POSITION} from '../../ecs/transitionHelper';
import flyInTopGif from '../../../assets/images/transitions/flyInTop.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_FLY_IN_TOP = 'flyInTop';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const flyInTopPresetDetails = {
  // The name of the preset.
  name: PRESET_FLY_IN_TOP,

  // A human friendly name for the preset.
  humanName: 'Fly In From Top',

  // A preview of the transition.
  gif: flyInTopGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'position.y': {
      // The name of the easing this property will use.
      easing: EASINGS.easeInQuad,

      // The start and end times for the transition of this property.
      time: {
        start: 'start.0',
        end: 'start.1000',
      },

      // The value of the property that will change during the transition.
      values: [`${PARSE_OFF}.top`, `${PARSE_POSITION}.top`],
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_FLY_IN_TOP,
    options: {},
  },
};

flyInTopPresetDetails.template.options = lodash.cloneDeep(flyInTopPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_FLY_IN_TOP;

// This defines the value of the presets object.
export default flyInTopPresetDetails;
